<template>
  <div class="dialogPage">
    <overlay :show="popBox" class="popBox" @click="popBoxBtn">
      <popup ref="popWrap" :show="popBox" name="slideUp" @close="popBox = false">
        <div class="popBox1" v-if="popBoxType === 1">
          <div class="popBox11" @click.stop>
            <div class="popBox2Bg">
              <div class="popBox2Bg1">活动规则</div>
            </div>
            <div class="popBox111">
              <p v-for="(item, index) in errMsgArr" :key="index">{{ item }}</p>
            </div>
          </div>
          <img class="popBox12" @click="popBoxBtn" src="./img/a2.png" alt="" />
        </div>

        <div class="popBox2" @click.stop v-if="popBoxType === 2">
          <img width="100%" src="./img/a9.png" alt="" />
          <div class="popBox21">
            <p class="popBox213">恭喜您获得立减金</p>
            <p class="popBox214">
              ￥
              <span class="popBox2141">{{ errMsg }}</span>
            </p>
            <p class="popBox2142">注:立减金是有有效期的哦，请尽快使用</p>
            <button class="popBox212" @click="popBoxBtn">{{ obj.okBtnText }}</button>
          </div>
        </div>

        <div class="popBox2" @click.stop v-if="popBoxType === 3">
          <div class="popBox2Bg"></div>
          <div class="popBox21">
            <img class="popBox215" src="./img/a11.png" alt="" />
            <!-- <p class="popBox216">领取失败</p> -->
            <p class="popBox211">{{ errMsg }}</p>
          </div>
        </div>

        <div class="popBox2" @click.stop v-if="popBoxType === 4">
          <div class="popBox2Bg"></div>
          <div class="popBox21">
            <img class="popBox215" src="./img/a13.png" alt="" />
            <p class="popBox216">{{ errTime.text }}</p>
            <p class="popBox2111" v-if="errTime.start && errTime.end">请于{{ errTime.start }} ~ {{ errTime.end }}参与活动</p>
          </div>
        </div>

        <div class="popBox2" @click.stop v-if="popBoxType === 5">
          <div class="popBox2Bg"></div>
          <div class="popBox21">
            <img class="popBox215" src="./img/a13.png" alt="" />
            <p class="popBox216">活动太火爆了，请稍后再试</p>
          </div>
        </div>

        <div class="popBox2" @click.stop v-if="popBoxType === 6">
          <div class="popBox2b1">
            <img class="popBox2b2" :src="obj.luckOkImg" alt="" />
            <p class="popBox2b3">{{ obj.luckOkTxt }}</p>
            <div class="popBox2b4" v-html="errMsg"></div>
            <p v-if="obj.awardType == '1'" class="popBox2b5">注:立减金是有有效期的哦，请尽快使用</p>
            <div class="popBox2b6" @click="popBoxBtn">{{ obj.okBtnText }}</div>
          </div>
        </div>

        <div class="popBox2 popBoxType7" @click.stop v-if="popBoxType === 7">
          <div class="popBox2b1">
            <img class="popBox2b8" :src="obj.luckFailImg" alt="" />
            <div class="popBox2b7">{{ errMsg }}</div>
            <div class="popBox2b6" @click="popBoxBtn">{{ obj.okBtnText }}</div>
          </div>
        </div>

        <div class="popBox2 popBoxType8" @click.stop v-if="popBoxType === 8">
          <div class="popBox2b1">
            <img class="popBox2b8" :src="obj.luckErrImg" alt="" />
            <div class="popBox2b7" v-html="errMsg"></div>
            <div class="popBox2b6" @click="popBoxBtn">{{ obj.okBtnText }}</div>
          </div>
        </div>

        <div class="popBox2 popBoxType8" @click.stop v-if="popBoxType === 80001">
          <div class="popBox2b1">
            <img class="popBox2b8" :src="obj.luckErrImg" alt="" />
            <div class="popBox2b7">{{ errMsg }}</div>
            <div class="popBox2b6" @click="popBoxBtn">{{ obj.okBtnText }}</div>
          </div>
        </div>

        <div class="popBox2" @click.stop v-if="popBoxType === 9">
          <div class="popBox2b1">
            <img class="popBox2b8" :src="obj.luckErrImg" alt="" />
            <div class="popBox2b7 popBox2b7A">{{ errMsg }}</div>
          </div>
        </div>
      </popup>
    </overlay>
  </div>
</template>

<script>
import popup from "../popup/index.vue";
import overlay from "../popup/overlay.vue";

export default {
  props: {
    source: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    popup,
    overlay,
  },
  data() {
    return {
      popBoxTypeUser: 1,
      popBox: false,
      popBoxType: 1,
      popBoxDoor: false,
      errMsg: "",
      errMsgArr: [],
      errTime: {
        start: "",
        end: "",
        text: "",
      },
      timer1: null,
      obj: {
        luckOkTxt: "恭喜啦",
        luckOkImg: require("./img/gold.png"),

        luckFailTxt: "",
        luckFailImg: require("./img/a14.png"),

        luckErrImg: require("./img/a15.png"),
        luckErrTxt: "离奖品就差一点点，加油哦",
        awardType: "1",
        okBtnText: "确定",
      },
    };
  },
  mounted() {
    this.reShow();
  },
  watch: {
    source: {
      handler() {
        this.reShow();
      },
      deep: true,
    },
  },
  methods: {
    reShow() {
      let fixobj = {};
      for (let i in this.source) {
        // this.source[i] !== "" &&
        if (this.source[i] !== null && this.source[i] !== undefined) {
          fixobj[i] = this.source[i];
        }
      }

      for (let i in fixobj) {
        this.obj[i] = fixobj[i];
      }
    },
    popBoxBtn() {
      if (this.popBoxDoor) return;
      if (this.popBoxType === 4) return;
      this.$refs.popWrap.closeUp();
      this.popBoxDoor = false;
      if (this.timer1) clearTimeout(this.timer1);
      this.timer1 = setTimeout(() => {
        this.$emit("alertOff", this.popBoxType);
      }, 300);
    },
    popUpMsg(i, j, k = false) {
      this.popBoxType = i;
      if (i === 6) {
        let imgBg = new Image();
        imgBg.src = this.obj.luckOkImg;
        imgBg.onload = () => {
          this.popBox = true;
        };
      } else {
        this.popBox = true;
      }
      this.popBoxDoor = k;
      this.errMsg = j;
      if (i === 1) {
        try {
          this.errMsgArr = this.errMsg && this.errMsg.split(/[\n,↵]/g);
        } catch (error) {
          this.errMsgArr = this.errMsg;
        }
        // if (this.timer1) clearTimeout(this.timer1)
        // this.timer1 = setTimeout(() => {
        //   this.popBoxBtn()
        // }, 2000)
      } else if (i === 4) {
        this.errTime = j;
      } else if (i === 7) {
        this.errMsg = j;
        if (this.obj.luckFailTxt) {
          this.errMsg = this.obj.luckFailTxt;
        }
      } else if (i === 8) {
        this.errMsg = j && j.replace(/(\|)/g, "<br />");
        if (this.obj.luckErrTxt) {
          this.errMsg = this.obj.luckErrTxt.replace(/(\|)/g, "<br />");
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogPage {
  .popBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    .popBox1 {
      .popBox11 {
        width: 81.333333vw;
        position: relative;
        .popBox2Bg {
          height: 77.333333vw;
          background: #fff;
          border-radius: 2.133333vw;
          border: 1.333333vw solid var(--main-color);
          .popBox2Bg1 {
            width: 30.133333vw;
            height: 8.8vw;
            line-height: 8.8vw;
            margin: 0 auto;
            background: var(--main-color);
            border-radius: 1.066667vw;
            font-size: 4.266667vw;
            text-align: center;
            transform: translateY(-1.333333vw);
            color: #fff;
          }
        }
        .popBox111 {
          position: absolute;
          width: 66.666667vw;
          top: 13.333333vw;
          left: 7.333333vw;
          font-size: 4.266667vw;
          color: #333;
          line-height: 5.866667vw;
          height: 61.333333vw;
          overflow: hidden;
          overflow-y: auto;
        }
      }
      .popBox12 {
        width: 5.866667vw;
        height: 5.866667vw;
        display: block;
        margin: 0 auto;
        transform: translateY(6.666667vw);
      }
    }
    .popBox2 {
      width: 81.333333vw;
      position: relative;
      .popBox2Bg {
        height: 77.333333vw;
        background: #fff;
        border-radius: 2.133333vw;
        border: 1.333333vw solid var(--main-color);
      }
      .popBox21 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        text-align: center;
      }
      .popBox2b1 {
        background: #fff;
        border-radius: 2.133333vw;
        width: 80vw;
        border: 1.333333vw solid var(--main-color);
        text-align: center;
      }
      .popBox2b2 {
        max-width: 50.666667vw;
        max-height: 28.533333vw;
        margin-top: 9.2vw;
      }
      .popBox2b3 {
        margin-top: 4vw;
        font-size: 6.666667vw;
        line-height: 9.2vw;
        font-weight: bold;
        color: #8c6700;
      }
      .popBox2b4 {
        margin-top: 1.866667vw;
        font-size: 4.266667vw;
        line-height: 4.266667vw;
        color: #8c6700;
      }
      .popBox2b5 {
        color: rgba(140, 103, 0, 0.5);
        font-size: 3.733333vw;
        line-height: 3.733333vw;
        margin-top: 4.533333vw;
      }
      .popBox2b6 {
        margin: 6.666667vw auto 9.333333vw;
        width: 62.666667vw;
        height: 10.666667vw;
        line-height: 10.666667vw;
        background: var(--main-color);
        font-size: 4.8vw;
        border-radius: 5.333333vw;
        color: #fff;
      }
      .popBox2b7 {
        font-size: 3.733333vw;
        line-height: 5.333333vw;
        margin-top: 4vw;
        color: rgba(140, 103, 0, 1);
      }
      .popBox2b7A {
        padding-bottom: 9.333333vw;
        font-size: 5.333333vw;
        line-height: 5.333333vw;
        color: var(--main-color);
      }
      .popBox2b8 {
        width: 16vw;
        height: 16vw;
        margin-top: 9.333333vw;
      }
      .popBox211 {
        color: #898b8d;
        font-size: 4.266667vw;
        line-height: 5.6vw;
      }
      .popBox2111 {
        color: #898b8d;
        font-size: 3.2vw;
        line-height: 5.6vw;
      }
      .popBox212 {
        border-radius: 13.066667vw;
        height: 13.066667vw;
        line-height: 13.066667vw;
        font-size: 4.266667vw;
        color: #ff1f30;
        background: linear-gradient(180deg, #ffecd4, #ffda93);
        width: 70.4vw;
        margin: 0 auto;
      }
      .popBox213 {
        font-size: 4.266667vw;
        line-height: 5.866667vw;
        margin-top: 10.4vw;
        margin-bottom: 1.733333vw;
        color: #bf7238;
      }
      .popBox214 {
        color: #ff1f30;
        font-size: 4.266667vw;
        line-height: 5.866667vw;
        .popBox2141 {
          font-size: 6.666667vw;
          line-height: 8vw;
          font-weight: bold;
        }
      }
      .popBox2142 {
        color: #d4d4d4;
        font-size: 3.2vw;
        margin-bottom: 24.133333vw;
      }
      .popBox215 {
        width: 16vw;
        height: 16vw;
        margin-top: 18.8vw;
        margin-bottom: 9.333333vw;
      }
      .popBox216 {
        font-size: 4.8vw;
        line-height: 4.8vw;
        color: var(--main-color);
        margin-bottom: 3.866667vw;
      }
    }
  }
}
</style>
